import { CompanyName } from '../models/company-name'

export const getCompanyIdByBrowserUrl = () => {
    const url = window?.location?.origin
    return url?.toUpperCase().includes(CompanyName.AVON)
      ? CompanyName.AVON
      : CompanyName.NATURA
}
